import { useMagicLinkLoginMutation } from 'api/core/generated';
import { AppApiVersions } from 'app-constants';

export const useLoginByMagicLink = () => {
  const [magicLinkLoginRequest, { data, loading, error }] =
    useMagicLinkLoginMutation({ context: { apiVersion: AppApiVersions.core } });

  const loginByMagicLink = (token: string) =>
    magicLinkLoginRequest({ variables: { token } });

  return {
    loginByMagicLink,
    loginByMagicLinkProcessing: loading,
    loginByMagicLinkSuccess: data?.success,
    loginByMagicLinkError: error,
  };
};
